module.exports = __webpack_public_path__ + "static/media/icon_close.3ec426f5.svg";